import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import ActivityPreviewSections from "../activity-preview/ActivityPreviewSections";
import { CurriculumComponent } from "../../redux/types";

const filterWorkoutSections = (sections: any) => {
  return sections?.filter((item) => item.type === "workout_section");
};

export interface IActivityPreviewProps {
  result: CurriculumComponent;
}

const WorkoutOverview = (props: IActivityPreviewProps) => {
  const { result } = props;
  const component = result;

  const [content, setContent] = useState(
    filterWorkoutSections(JSON.parse(component.content)),
  );

  useEffect(() => {
    setContent(filterWorkoutSections(JSON.parse(result.content)));
  }, [result]);

  if (!component) return <></>;

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", height: "fit-content" }}
    >
      {content.length !== 0 ? (
        content.map((c, index) => (
          <ActivityPreviewSections card={c} index={index} />
        ))
      ) : (
        <Typography
          sx={{
            fontWeight: 500,
            fontStyle: "italic",
          }}
        >
          <>
            No exercises yet.
            <br /> Click Edit to create some.
          </>
        </Typography>
      )}
    </Box>
  );
};

export default WorkoutOverview;
